<ng-container *ngIf="{
    row: columnData | async
  } as $">

    <p-badge
        *ngIf="$.row.payment_status && ($.row.payment_status == paymentStatus.Successfull || $.row.payment_status.toString() == paymentStatus[paymentStatus.Successfull])"
        severity="success" [value]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.PAID' | translate" styleClass="uppercase border-round text-xxs text-white">
    </p-badge>
    <p-badge
        *ngIf="$.row.payment_status && ($.row.payment_status == paymentStatus.Failed || $.row.payment_status.toString() == paymentStatus[paymentStatus.Failed])"
        severity="danger" [value]="'SUBSCRIPTIONS.PAYMENT_TIMELINE.FAILED' | translate" styleClass="uppercase border-round text-xxs">
    </p-badge>
</ng-container>